"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.findSupportedFile = exports.SupportedFiles = exports.MEDIA_MAX_BYTES = void 0;
const HttpInterface_1 = require("./HttpInterface");
/** Default media-library upload cap (non-Shorts). */
exports.MEDIA_MAX_BYTES = 40 * 1024 * 1024; // 40 MB
exports.SupportedFiles = [
    { extensions: ["jpg", "jpeg"], mime: "image/jpeg", type: HttpInterface_1.ContentType.IMAGE },
    { extensions: ["png"], mime: "image/png", type: HttpInterface_1.ContentType.IMAGE },
    { extensions: ["gif"], mime: "image/gif", type: HttpInterface_1.ContentType.IMAGE },
    { extensions: ["webp"], mime: "image/webp", type: HttpInterface_1.ContentType.IMAGE },
    { extensions: ["mp4"], mime: "video/mp4", type: HttpInterface_1.ContentType.VIDEO },
    { extensions: ["webm"], mime: "video/webm", type: HttpInterface_1.ContentType.VIDEO },
    { extensions: ["avi"], mime: "video/x-msvideo", type: HttpInterface_1.ContentType.VIDEO },
    { extensions: ["mov"], mime: "video/quicktime", type: HttpInterface_1.ContentType.VIDEO },
    { extensions: ["wmv"], mime: "video/x-ms-wmv", type: HttpInterface_1.ContentType.VIDEO },
];
/** Browsers often misreport MIME for renamed or test files on Windows. */
const UNRELIABLE_MIMES = new Set([
    "",
    "application/octet-stream",
    "text/plain",
]);
const findSupportedFile = (mime, extension) => {
    const ext = extension === null || extension === void 0 ? void 0 : extension.toLowerCase().replace(/^\./, "");
    if (ext && UNRELIABLE_MIMES.has(mime)) {
        return exports.SupportedFiles.find((x) => x.extensions.includes(ext));
    }
    const meta = exports.SupportedFiles.find((x) => x.mime === mime);
    if (!meta) {
        return undefined;
    }
    if (ext && !meta.extensions.includes(ext)) {
        return undefined;
    }
    return meta;
};
exports.findSupportedFile = findSupportedFile;
